/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type BankAccount = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export const BankAccount = gql`
    fragment BankAccount on BankInfo {
  id
  accountHolderName
  accountNumberLength
  accountNumberLastFour
  bankName
  routingNumber
  source
  externalConnectionGuid
  logoUrl
}
    `;